export default __webpack_public_path__ + "src/UI/Logo/logo_png-4991e751bb113511a30e11f8d994073b.png";